/* istanbul ignore file */
import {
  Grid,
  Text,
  PageLayout,
  Footer,
  FocusedAuctionApplication,
  FeatureFlags,
  ProductLine,
  AnimatedProgressBar,
  constants,
} from '@adc/ui-adc'
import configment from '@adc/configment'
import classname from 'classnames/bind'
import { propertyFixture } from '../../../../test/fixtures/property'
import { PropertyBox } from './propertyBox'
import Line25 from '../../assets/line_25.svg'
import ClaimProcess from './claimProcess'
import SellerSuccess from './sellerSuccess'
import ResultStats from './resultStats'
import FaqList from './faqList'
import { connect } from 'react-redux'
import {
  StepManagerProvider as CMLStepManagerProvider,
  useStepManagerContext,
} from './progressManager'
import styles from './styles.scss'

const cx = classname.bind(styles)

const { ColorNames } = constants

const FlowProgressBar = () => {
  const { manager } = useStepManagerContext()
  const { progress } = manager
  return (
    <AnimatedProgressBar
      percent={progress < 1 ? 1 : progress}
      color={ColorNames.AdcLightGreen}
      className={cx('progress-bar')}
    />
  )
}

const ClaimMyListing = ({
  user,
  featureFlags,
}: {
  user: any
  featureFlags: FeatureFlags
}) => {
  const capabilities = { surveyMonkey: { enabled: false } }
  const helmetConfig = {
    title: '',
  }
  return (
    <CMLStepManagerProvider history={history}>
      <FlowProgressBar />
      <FocusedAuctionApplication
        user={user}
        featureFlags={featureFlags}
        sspConfig={configment.get()}
        helmetConfig={helmetConfig}
        capabilities={capabilities}
        hideHeader
        // @ts-ignore
        theme={{ productLine: ProductLine.SmartSale }}
      >
        <PageLayout width='large' className={cx('claim-my-listing-container')}>
          <Grid>
            <Grid.Row collapse={{ small: true }}>
              <Grid.Column width={16}>
                <Text.Header compact elmId='landing_page_title_1'>
                  Here's what we have—
                </Text.Header>
                <Text.Header elmId='landing_page_title_2'>
                  Let's confirm it is accurate
                </Text.Header>
                <Text elmId='landing_page_subtitle_1'>
                  Your property details were auto-filled from your QR code or
                  link.
                </Text>
                <Text elmId='landing_page_subtitle_2'>
                  Please verify the information below.
                </Text>
                <PropertyBox property={propertyFixture()} />
                <img src={Line25} alt='' className={cx('divider-line')} />
              </Grid.Column>
            </Grid.Row>
            <Grid.Row collapse={{ small: true }}>
              <Grid.Column width={16}>
                <ClaimProcess />
              </Grid.Column>
            </Grid.Row>
            <Grid.Row collapse={{ small: true }}>
              <Grid.Column width={16}>
                <SellerSuccess />
              </Grid.Column>
            </Grid.Row>
            <Grid.Row collapse={{ small: true }}>
              <Grid.Column width={16}>
                <ResultStats />
              </Grid.Column>
            </Grid.Row>
            <Grid.Row collapse={{ small: true }}>
              <Grid.Column width={16}>
                <FaqList />
              </Grid.Column>
            </Grid.Row>
          </Grid>
          <section>
            <Footer />
          </section>
        </PageLayout>
      </FocusedAuctionApplication>
    </CMLStepManagerProvider>
  )
}

const mapStateToProps = (store: any) => {
  return {
    user: store.user,
    form: store.form,
    featureFlags: store.featureFlags,
  }
}

export default connect(mapStateToProps)(ClaimMyListing)
